import {
  ComponentInternalInstance,
  computed,
  getCurrentInstance,
  onUnmounted,
  reactive,
  ref,
} from '@vue/composition-api';
import _ from 'lodash';
import ipc from '@/renderer/scripts/utils/ipc';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';

// 退出搜索
const resetSearch = ipc.RENDERER_EVENTS_MAP.RESET_SEARCH;
export default function searchHandler1() {
  const currComponent: ComponentInternalInstance | null = getCurrentInstance();
  const vm = (currComponent as ComponentInternalInstance).proxy;
  const { $store } = vm;
  const searchPreviousRoute = computed(() => $store.getters.searchPreviousRoute);

  // 搜索关键字
  const searchKeyword = ref('');
  const searchParams = reactive({
    keyword: '',
    scope: 'all',
  });
  const methods = {
    /**
     * @description 打开搜索
     * @param {{ keyword: string; scope: string }} params
     */
    openSearch(params: { keyword: string; scope: string }) {
      searchParams.keyword = params.keyword.trim();
      searchParams.scope = params.scope;
      // 存取搜索路由相关信息：跳转路由信息、搜索关键字和搜索范围
      if (vm.$route.name !== 'search') {
        const { name, query, params } = vm.$route;
        // 去除fromRoute参数，避免带来干扰
        const newQuery = query?.fromRoute ? _.omit(query, 'fromRoute') : query;
        $store.commit('SET_SEARCH_PREVIOUSROUTE', {
          name,
          query: newQuery,
          params,
        });
        $store.commit('SET_SEARCH_SCOPE', searchParams.scope);
        $store.commit('SET_SEARCH_KEYWORD', searchParams.keyword);
        dispatchRouter({
          name: 'search',
          query: {
            keyword: searchParams.keyword,
          },
        });
      }
    },
    /**
     * @description 重置搜索
     */
    resetSearch() {
      searchKeyword.value = '';
    },
    /**
     * @description 退出搜索
     */
    exitSearch() {
      // 兜底处理
      const defaultRouteName = !$store.getters.isMobileStyle ? 'workbench' : 'recentUse';
      dispatchRouter({
        name: searchPreviousRoute.value.name || defaultRouteName,
        query: searchPreviousRoute.value.query,
      });
    },
  };
  ipc.on(resetSearch, methods.resetSearch);
  onUnmounted(() => {
    ipc.off(resetSearch, methods.resetSearch);
  });
  return {
    searchKeyword,
    methods,
  };
}
